import { LOCALES, LOCALE_NAMES, useT, type Locale } from "@/i18n";

// The four-language dropdown: on the sign-in page and in the header, so nobody ever has to read a
// language they did not choose — not even before signing in.
export default function LanguagePicker() {
  const { t, locale, setLocale } = useT();
  return (
    <select value={locale} onChange={(e) => setLocale(e.target.value as Locale)}
      className="rounded border border-slate-300 bg-white px-2 py-1 text-sm" aria-label={t("lang.label")}>
      {LOCALES.map((l) => <option key={l} value={l} lang={l}>{LOCALE_NAMES[l]}</option>)}
    </select>
  );
}
